import { NiveisTurmas } from './niveis-turmas';
import { Unidade } from './unidade';

export class MatriculaSecretaria {
    id: number;
	descricao: string;
	turno: string;
	unidade: Unidade;
	nivelTurma: NiveisTurmas;
	usuarioAplicacaoId: number;
}